export default __webpack_public_path__ + "ee643395cce51b2233ea889be5c12f90.svg";